<template>
  <div>
    <h1>Shopify logout</h1>
  </div>
</template>

<script>
export default {

}
</script>\